/* ===========================================================================
   Safer Lighting — exit-intent / welcome capture.
   • Desktop: fires when the cursor leaves the top of the viewport (exit intent).
   • Touch devices: never shown (no hover exit signal; never trigger on scroll).
   • Suppressed for N days once seen; never shown again once a code is claimed.
   • Email capture uses Shopify's native customer form (AJAX), then reveals the
     discount code instantly. No 3rd-party scripts, no custom backend.
   Config comes from data-* attributes on the root element (set in Liquid).
   =========================================================================== */
(function () {
  var root = document.querySelector('[data-sl-exit]');
  if (!root) return;

  // Don't interrupt cart / account / checkout flows.
  var p = location.pathname;
  if (/^\/(cart|account|checkout)/.test(p)) return;

  var CODE = (root.getAttribute('data-code') || 'SAFER15').trim();
  var DAYS = parseInt(root.getAttribute('data-days') || '14', 10);
  var KEY_SEEN = 'sl_exit_seen';
  var KEY_DONE = 'sl_exit_done';

  function ls(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lss(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  // Already converted, or seen within the suppression window? Bail.
  if (ls(KEY_DONE)) return;
  var seen = parseInt(ls(KEY_SEEN) || '0', 10);
  if (seen && (Date.now() - seen) < DAYS * 86400000) return;

  var card = root.querySelector('.sl-exit__card');
  var offer = root.querySelector('[data-sl-exit-offer]');
  var success = root.querySelector('[data-sl-exit-success]');
  var form = root.querySelector('form');
  var input = root.querySelector('.sl-exit__input');
  var submit = root.querySelector('.sl-exit__submit');
  var errEl = root.querySelector('.sl-exit__error');
  var opened = false;
  var lastFocus = null;

  function open() {
    if (opened) return;
    opened = true;
    lss(KEY_SEEN, String(Date.now()));
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    // next frame for the transition
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    setTimeout(function () { (input || card).focus(); }, 60);
    document.addEventListener('keydown', onKey);
    teardownTriggers();
  }

  function close() {
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    setTimeout(function () {
      root.hidden = true;
      if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
    }, 340);
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') trapFocus(e);
  }

  function trapFocus(e) {
    var f = root.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function showError(msg) {
    if (!errEl) return;
    errEl.textContent = msg;
    errEl.classList.add('is-shown');
  }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function onSubmit(e) {
    e.preventDefault();
    if (errEl) errEl.classList.remove('is-shown');
    var email = (input.value || '').trim();
    if (!EMAIL_RE.test(email)) { showError('Please enter a valid email address.'); input.focus(); return; }

    submit.disabled = true;
    // Best-effort capture via Shopify's native customer endpoint; we reveal the
    // code optimistically so the shopper gets instant gratification regardless.
    try {
      var fd = new FormData(form);
      fetch(form.getAttribute('action') || '/contact', {
        method: 'POST', body: fd, headers: { 'Accept': 'text/html' }, credentials: 'same-origin'
      }).catch(function () {});
    } catch (err) {}

    lss(KEY_DONE, '1');
    reveal();
  }

  function reveal() {
    if (offer) offer.hidden = true;
    if (success) success.hidden = false;
    var codeBtn = root.querySelector('[data-sl-exit-code]');
    if (codeBtn) setTimeout(function () { codeBtn.focus(); }, 40);
  }

  // copy-to-clipboard on the code chip
  root.addEventListener('click', function (e) {
    var codeBtn = e.target.closest('[data-sl-exit-code]');
    if (!codeBtn) return;
    var label = codeBtn.querySelector('small');
    function done() { if (label) { var t = label.textContent; label.textContent = 'copied'; setTimeout(function () { label.textContent = t; }, 1600); } }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(CODE).then(done, done);
    else done();
  });

  // close handlers
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-sl-exit-close]')) { e.preventDefault(); close(); }
  });
  if (form) form.addEventListener('submit', onSubmit);

  // ---- triggers ----------------------------------------------------------

  function onMouseOut(e) {
    if (e.clientY <= 0 && !e.relatedTarget) open();
  }
  function teardownTriggers() {
    document.removeEventListener('mouseout', onMouseOut);
  }

  // Desktop mouse-leave only. Touch / coarse-pointer devices have no exit
  // signal, and CLAUDE.md forbids scroll triggers — so they never see it.
  var isTouch = ('ontouchstart' in window) || navigator.maxTouchPoints > 0 ||
    (window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  if (!isTouch) {
    // give the page a moment so it never fires on initial load jitter
    setTimeout(function () { document.addEventListener('mouseout', onMouseOut); }, 4000);
  }
})();
